/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type UserType = (typeof UserType)[keyof typeof UserType];

export const UserType = {
    Homeowner: 1,
    PropertyValuer: 2,
    Architect: 3,
    Lawyer: 4,
    Conveyancer: 5,
    Insurer: 6,
    PropertyManager: 7,
    FacilitiesManager: 8,
    MaintenanceTechnician: 9,
    AssetManager: 10,
    PortfolioManager: 11,
    RealEstateDeveloper: 12,
    BuildingOwner: 13,
    LeasingManager: 14,
    OperationsManager: 15,
    ProjectManager: 16,
    ComplianceOfficer: 17,
    SafetyManager: 18,
    EnergyManager: 19,
    BuildingSuperintendent: 20,
    RealEstateAnalyst: 21,
    SustainabilityManager: 22,
    ConstructionManager: 23,
    BuildingAutomationSpecialist: 24,
    HvacTechnician: 25,
    Consultant: 26,
    Other: 27,
    StrataManager: 28,
    BuildingSurveyor: 29,
} as const;
